// src/App.js
import React, { useEffect, useState } from "react";

import AppRoutes from "./AppRoutes";
import LogoLoader from "./Pages/LogoLoader";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setLoading(false);
    }, 4000); // 2 seconds
    return () => clearTimeout(timer);
  }, []);

  return <>{loading ? <LogoLoader /> : <AppRoutes />}</>;
}

export default App;
